import React, { useEffect, useRef, useState } from "react";
import "./customer.css";
import { getDispositions, workorderdetails } from "../services/merpservices";
import GroupDisposition from "./GroupDisposition";
import UserDetails from "./UserDetails";
import { getPaidFreeCustFlag } from "../components/inboundCenter";
import { gaEvent } from "../utils/GoogleAnalytics/gatracking";
import Tabs from '../Tabs/Tabs'
import { useGlobalContext } from "../context/AppGlobalContext";

const CustomerDetails = ({empid, ak, glid, businessNature, phtype}) => {
  const [selectedTab, setSelectedTab] = useState(null);
  const [selectedAccountRelatedTab, setSelectedAccountRelatedTab] = useState("");
  const [groupDispData, setGroupDispData] = useState([]);
  const [catDispData, setCatDispData] = useState([]);
  const [descDispValue, setDescDispValue] = useState([]);
  const [workOrderData, setWorkOrderData] = useState([]);
  const [workOrderWipCount, setworkOrderWipCount] = useState(0);
  const [tabResolved, setTabResolved] = useState(false);
  const { custId, assignedGlid } = useGlobalContext();
  const grpDispFetched = useRef(false);
  const fetchedWOGlid = useRef(null);
  const [descId, setDescId] = useState("");
  const [disableConnectSellerBtn, setDisableConnectSellerBtn] = useState(false);
  const [connectSellerStatus, setConnectSellerStatus] = useState('');

  const handleTabClick = (val) => {
    setSelectedTab(val);
    setSelectedAccountRelatedTab('');
    setDescDispValue([]);
  };

  const supplierCategoriesData = [
    { "GL_DISP_CAT_ID": "56", "GL_DISP_CAT_NAME": "Registration", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "26", "GL_DISP_CAT_NAME": "Hot Lead", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "46", "GL_DISP_CAT_NAME": "Deactivation", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "24", "GL_DISP_CAT_NAME": "Catalog", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "45", "GL_DISP_CAT_NAME": "Activation", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "31", "GL_DISP_CAT_NAME": "Account Related", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "28", "GL_DISP_CAT_NAME": "Others", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "48", "GL_DISP_CAT_NAME": "Enquiry", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "47", "GL_DISP_CAT_NAME": "BuyLead", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "29", "GL_DISP_CAT_NAME": "PNS", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "27", "GL_DISP_CAT_NAME": "App", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "54", "GL_DISP_CAT_NAME": "Issue at Buyer", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "50", "GL_DISP_CAT_NAME": "Invoice", "FK_GL_DISP_GRP_ID": "8" },
    { "GL_DISP_CAT_ID": "30", "GL_DISP_CAT_NAME": "Tenders", "FK_GL_DISP_GRP_ID": "8" },
  ];

  const buyerCategoriesData = [
    { "GL_DISP_CAT_ID": "18", "GL_DISP_CAT_NAME": "Buy Lead Related", "FK_GL_DISP_GRP_ID": "7" },
    { "GL_DISP_CAT_ID": "20", "GL_DISP_CAT_NAME": "No BL/No Connect", "FK_GL_DISP_GRP_ID": "7" },
    { "GL_DISP_CAT_ID": "53", "GL_DISP_CAT_NAME": "Issue at Supplier end", "FK_GL_DISP_GRP_ID": "7" },
    { "GL_DISP_CAT_ID": "43", "GL_DISP_CAT_NAME": "IndiaMART Payment Protection", "FK_GL_DISP_GRP_ID": "7" },
  ];

  const handleAccountRelatedTabClick = (val) => {
    setSelectedAccountRelatedTab(val);
    handleDescriptionTabClick(selectedTab, val);
  };

  const handleDescriptionTabClick = (grpId, catId) => {
    desDisposition(grpId, catId);
  };

  const wODetails = async (glid, check, woid, custId) => {
    if (custId !== '') {
      let res = await workorderdetails(empid, ak, glid, check, woid);
      let count = 0;
      if (woid === '') {
        if (res?.data?.status === 200) {
          res = res?.data?.data;
          setWorkOrderData(res?.workOrderData);
          if (res?.workOrderData !== null) {
            for (let i = 0; i < res?.workOrderData.length; i++) {
              if (res?.workOrderData[i].WO_STATUS === "W-I-P") {
                count += 1;
              }
            }
            setworkOrderWipCount(count);
          }
        }
      }

      if ((getPaidFreeCustFlag(parseInt(custId)) === 1) || count > 0) {
        setSelectedTab("8");
      } else {
        setSelectedTab("7");
      }
      setTabResolved(true);
    }
  };

  const getDispositionData = async (conditon, setStateFunction, property) => {
    try {
      if (ak !== null) {
        var response = await getDispositions(empid, ak, conditon);
        if (response.status) {
          response = response.data.data[property];
          if (response !== undefined) {
            setStateFunction(response);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const condition = (params) => {
    const searchParams = new URLSearchParams(params);
    return searchParams.toString();
  };

  const grpDispostion = async () => {
    const conditon = condition({ check: 'g' });
    getDispositionData(conditon, setGroupDispData, 'group');
  };

  const catDisposition = async (grpId) => {
    if (grpId !== '8' && grpId !== '7') {
      const url = condition({ check: 'c', groupId: grpId });
      getDispositionData(url, setCatDispData, 'category');
    }
  };

  const desDisposition = async (grpId, catId) => {
    const url = condition({ check: 'd', groupId: grpId, categoryId: catId });
    getDispositionData(url, setDescDispValue, 'description');
  };

  useEffect(() => {
    if (empid && !grpDispFetched.current) {
      grpDispFetched.current = true;
      grpDispostion();
    }
  }, []);

  useEffect(() => {
    if (!glid) {
      setSelectedTab(prev => prev ?? "7");
      setWorkOrderData([]);
      setworkOrderWipCount(0);
      setTabResolved(true);
    }
  }, [glid]);

  useEffect(() => {
    if (empid && glid && assignedGlid === glid && fetchedWOGlid.current !== glid) {
      fetchedWOGlid.current = glid;
      setTabResolved(false);
      wODetails(glid, 'g', '', custId);
    }
  }, [assignedGlid]);

  useEffect(() => {
    if (selectedTab) {
      catDisposition(selectedTab);
    }
  }, [selectedTab]);

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const prevSelectedTab = usePrevious(selectedTab);

  const gaTrackingOnDisposition = () => {
    const prevArray = {
      7: 'Buyer',
      8: 'Supplier',
      9: 'User'
    };
    if (prevSelectedTab !== selectedTab && prevSelectedTab !== undefined) {
      gaEvent(
        'Submit Disposition- Customers concern New',
        'Group Disposition Change New',
        'Group Disposition Change New',
        `Changed from ${prevArray[prevSelectedTab]} to ${prevArray[selectedTab]}`,
        glid,
      );
    }
  };

  useEffect(() => {
    gaTrackingOnDisposition(prevSelectedTab, selectedTab);
  }, [prevSelectedTab, selectedTab]);

  return (
    <main>
      <section className="pb-5">
        <div className="container-fluid">
          <GroupDisposition
            groupDispData={groupDispData}
            selectedTab={selectedTab}
            handleTabClick={handleTabClick}
            catDispData={
              selectedTab === '8' ? supplierCategoriesData :
              selectedTab === '7' ? buyerCategoriesData :
              catDispData
            }
            selectedAccountRelatedTab={selectedAccountRelatedTab}
            handleAccountRelatedTabClick={handleAccountRelatedTabClick}
          />

          {selectedTab !== null && (
            <UserDetails
              selectedTab={selectedTab}
              descDispValue={descDispValue}
              glid={glid}
              empid={empid}
              ak={ak}
              businessNature={businessNature}
              phtype={phtype}
              disableConnectSellerBtn={setDisableConnectSellerBtn}
              setDescId={setDescId}
              connectSellerStatus={setConnectSellerStatus}
              selectedAccountRelatedTab={selectedAccountRelatedTab}
            />
          )}

          {(document.location.pathname === "/Controllers/inBoundCenter.php" || document.location.pathname === "/api/html") && 
            <Tabs 
              empid={empid}
              ak={ak}
              glid={glid}
              workOrderDetails={workOrderData}
              wipWoCount={workOrderWipCount}
              selectedTab={selectedTab}
              selectedAccountRelatedTab={selectedAccountRelatedTab}
              disableConnectSellerBtn={disableConnectSellerBtn}
              phtype={phtype}
              descId={descId}
              connectSellerStatus={connectSellerStatus}
              custId={custId}
            />
          }
        </div>
        <input id="grpDispValue" value={selectedTab ?? ''} type="text" hidden />
        <input id="catDispValue" value={selectedAccountRelatedTab} type="text" hidden />
      </section>
    </main>
  );
};

export default CustomerDetails;